var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("sys-select-base", {
        attrs: {
          model: _vm.selected,
          items: _vm.items,
          loading: _vm.loading,
          label: _vm.label,
          error: _vm.error,
          errors: _vm.errors,
          clearable: _vm.clearable,
          showAdd: _vm.showAdd,
          dense: _vm.dense,
          itemText: _vm.itemText,
          autoComplete: _vm.autoComplete,
          multiple: _vm.multiple,
          outlined: _vm.outlined,
          selectAll: _vm.selectAll,
          returnObject: _vm.returnObject,
        },
        on: {
          "update:model": function ($event) {
            _vm.selected = $event
          },
          onShowForm: function ($event) {
            _vm.showForm = true
          },
          change: function ($event) {
            return _vm.$emit("change", _vm.$ev)
          },
        },
      }),
      _c("sys-register-teacher-position", {
        attrs: { model: {}, show: _vm.showForm },
        on: {
          onCompleted: _vm.newItem,
          "update:show": function ($event) {
            _vm.showForm = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }